// Employee/styles/MonthViewStyles.ts

// commerce/components/employee/styles/MonthViewStyles.ts
export const styles = {
    wrapper: {
        backgroundColor: "none",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    tableWrapper: {
        flexGrow: 1,
        overflow: "auto",
    },
    table: {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        backgroundColor: "none",
    },
    headerCell: {
        width: "14.28%",
        textAlign: "center",
        backgroundColor: "none",
        position: "sticky",
        top: 0,
        zIndex: 1,
    },
    tableRow: {
        height: "auto",
    },
    dayColumn: {
        backgroundColor: "none",
        padding: "8px",
        position: "relative",
        verticalAlign: "top",
        width: "14.28%",
        userSelect: "none",
        "&.not-current-month": {
            backgroundColor: "#999 !important",
            color: "#666 !important",
        },
    },
    dateNumber: {
        fontSize: "0.875rem",
        fontWeight: "bold",
        marginBottom: "4px",
    },
    eventsContainer: {
        marginTop: "4px",
        "@media (max-width: 768px)": {
            marginTop: "2px",
        },
    },
    eventCard: {
        backgroundColor: "#1e1e1e",
        userSelect: "none",
        borderRadius: "4px",
        padding: "4px",
        marginBottom: "4px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
        "&:hover": {
            cursor: "pointer",
            backgroundColor: "#333",
        },
    },
    eventTitle: {
        fontSize: "0.75rem",
        fontWeight: "bold",
        "@media (max-width: 768px)": {
            fontSize: "0.65rem",
        },
        "@media (max-width: 468px)": {
            fontSize: "0.60rem",
        },
    },
    eventTime: {
        fontSize: "0.625rem",
        "@media (max-width: 768px)": {
            fontSize: "0.6rem",
        },
        "@media (max-width: 468px)": {
            fontSize: "0.55rem",
        },
        editButton: {
            alignSelf: "flex-end",
            padding: "2px 4px",
            minWidth: "auto",
            fontSize: "0.7rem",
        },
    },
};
